var orderDataTemplate = {
	tableTemp: {
		panels: [
			{
				index: 0,
				paperType: 'A4',
				height: 297,
				width: 210,
				paperHeader: 49.5,
				paperFooter: 824,
				printElements: [
					{
						options: {
							left: 1.5,
							top: 19.5,
							height: 9.75,
							width: 592.5,
							title: '特规通正版图书订单',
							fontSize: 15,
							fontWeight: 'bold',
							textAlign: 'center'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 10.5,
							top: 51,
							height: 9.75,
							width: 340.5,
							title: '客户名称',
							field: 'consumerCode',
							testData: '唐山市翔云图书销售有限公司'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 414,
							top: 51,
							height: 9.75,
							width: 177,
							title: '销售单号',
							field: 'tradeNo',
							testData: 'CO2026052017792636727009481'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 174,
							top: 69,
							height: 9.75,
							width: 120,
							title: '总品种',
							field: 'tradeOrderTypeTotal',
							testData: '10'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 336,
							top: 69,
							height: 9.75,
							width: 120,
							title: '总码洋',
							field: 'beforeAmountTotal',
							testData: '1981.0'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 460.5,
							top: 69,
							height: 9.75,
							width: 120,
							title: '付款方式',
							field: 'payTypeStr',
							testData: '对公转账'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 10.5,
							top: 69,
							height: 9.75,
							width: 120,
							title: '快递费用',
							field: 'freightAmount',
							testData: '0'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 336,
							top: 87,
							height: 9.75,
							width: 114,
							title: '总实洋',
							field: 'afterAmountTotal',
							testData: '1304.92'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 174,
							top: 87,
							height: 9.75,
							width: 120,
							title: '总数量',
							field: 'buyNumTotal',
							testData: '28'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 460.5,
							top: 87,
							height: 9.75,
							width: 120,
							title: '总应收',
							field: 'totalAmount',
							testData: '1304.92'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 10.5,
							top: 87,
							height: 9.75,
							width: 120,
							title: '备注',
							field: 'remark'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 336,
							top: 105,
							height: 9.75,
							width: 114,
							title: '收货人',
							field: 'receiverName',
							testData: '吴亚军'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 10.5,
							top: 105,
							height: 9.75,
							width: 310.5,
							title: '收货地址',
							field: 'receiverAddress',
							testData: '河北省唐山路北区翔云道36号（翔云建筑书店）'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 460.5,
							top: 105,
							height: 9.75,
							width: 120,
							title: '收货手机',
							field: 'receiverPhone',
							testData: '15853356458'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 10.5,
							top: 127.5,
							height: 36,
							width: 574,
							field: 'tradeOrderDetails',
							tableHeaderBackground: '#ffffff',
							tableHeaderCellBorder: 'noBorder',
							tableBodyCellBorder: 'noBorder',
							tableBorder: 'noBorder',
							tableHeaderBorder: 'noBorder',
							tableBodyRowBorder: 'topBorder',
							styler: () => {
								return {
									'border-top': '1px solid #000000',
									'border-bottom': '1px solid #000000'
								};
							},
							columns: [
								[
									{
										title: '序号',
										field: 'no',
										width: 25.579322638146166,
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'no',
										styler: () => {
											return {
												paddingLeft: '5px',
											};
										}
									},
									{
										title: '类型',
										field: 'isDigitStr',
										width: 40.92691622103387,
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'isDigitStr',
									},
									{
										title: '书号',
										field: 'barCode',
										width: 61.3903743315508,
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'barCode',
										styler: () => {
											return {
												padding: '5px'
											};
										}
									},
									{
										title: '书名',
										field: 'name',
										width: 145.05882352941177,
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'name',
										styler: () => {
											return {
												paddingRight: '15px',
												paddingTop: '5px',
												paddingBottom: '5px',
											};
										}
									},
									{
										title: '出版社',
										field: 'deptName',
										width: 67.76114081996435,
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'deptName'
									},
									{
										title: '定价',
										field: 'fixedPrice',
										width: 40.92691622103387,
										align: 'right',
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'fixedPrice'
									},
									{
										title: '折扣',
										field: 'discount',
										width: 40.92691622103387,
										align: 'right',
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'discount'
									},
									{
										title: '数量',
										field: 'buyNum',
										width: 40.92691622103387,
										align: 'center',
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'buyNum'
									},
									{
										title: '码洋',
										field: 'beforeAmount',
										width: 55.25133689839572,
										align: 'right',
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'beforeAmount'
									},
									{
										title: '实洋',
										field: 'afterAmount',
										width: 55.25133689839572,
										align: 'right',
										colspan: 1,
										rowspan: 1,
										checked: true,
										columnId: 'totalPrice',
										styler: () => {
											return {
												paddingRight: '5px'
											};
										}
									}
								]
							]
						},
						printElementType: {
							title: '表格',
							type: 'tableCustom'
						}
					},
					{
						options: {
							left: 10.5,
							top: 181.5,
							height: 9.75,
							width: 196.5,
							title: '订单生成时间',
							field: 'createTime',
							testData: '2026-06-04 15:32:21'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 229.5,
							top: 199.5,
							height: 9.75,
							width: 208.5,
							title: '地址：北京市朝阳区胜古中路企发大厦F座819室'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 466.5,
							top: 199.5,
							height: 9.75,
							width: 120,
							title: '电话：010-64430169'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 10.5,
							top: 199.5,
							height: 9.75,
							width: 187.5,
							title: '图书销售单位：北京品读文化发展有限公司\n'
						},
						printElementType: {
							type: 'text'
						}
					},
					{
						options: {
							left: 10.5,
							top: 219,
							height: 9.75,
							width: 550.5,
							title: '订单说明：本订单由“特规通”平台自动生成，特规通平台销售的正版法规标准及图书均由北京品读文化发展有限公司提供。'
						},
						printElementType: {
							type: 'text'
						}
					}
				],
				paperNumberLeft: 565,
				paperNumberTop: 819
			}
		]
	}
};

export default orderDataTemplate;
